/**
 * Configuration centralisée - lit les variables d'environnement VUE_APP_*
 * Compatible avec l'ancienne structure cca_config
 */

const cca_config = {
    VUE_APP_NAME: process.env.VUE_APP_NAME || 'Clinicaa | Clinique',

    MODULE: {
        clinique: { port: '', name: '' },
        caisse: { port: '' },
        stock: { port: '' },
        rh: { port: '' },
    },

    // C_URL n'est plus utilisé - les URLs API sont complètes
    C_URL: '',

    // Frontend URLs
    C_CLINIQUE_FE_URL: process.env.VUE_APP_CLINIQUE_FE_URL || '',
    C_CAISSE_FE_URL: process.env.VUE_APP_CAISSE_FE_URL || '',
    C_STOCK_FE_URL: process.env.VUE_APP_STOCK_FE_URL || '',
    C_RH_FE_URL: process.env.VUE_APP_RH_FE_URL || '',

    // Backend API URLs (complètes, pas de concaténation nécessaire)
    C_URL_CLINIQUE_API: process.env.VUE_APP_CLINIQUE_API || '',
    C_URL_CAISSE_API: process.env.VUE_APP_CAISSE_API || '',
    C_URL_CONFIG_API: process.env.VUE_APP_CONFIG_API || '',
    C_URL_STOCK_API: process.env.VUE_APP_STOCK_API || '',

    // Assets URLs
    C_URL_ASSET: process.env.VUE_APP_ASSET_URL || '',
    C_URL_CAISSE_ASSET: process.env.VUE_APP_CAISSE_ASSET_URL || '',

    // Locale
    COUNTRY_CODE: process.env.VUE_APP_COUNTRY_CODE || 'tg',
    VILLE: process.env.VUE_APP_VILLE || 'Lomé',

    // Footer texts
    FOOT_1: process.env.VUE_APP_FOOT_1 || '',
    FOOT_2: process.env.VUE_APP_FOOT_2 || '',
    FOOT_ORD: process.env.VUE_APP_FOOT_ORD || '',

    // Document settings
    PDL_PAPIER_ENTETE: process.env.VUE_APP_PDL_PAPIER_ENTETE || '',
    TYPE_CLINIQUE: process.env.VUE_APP_TYPE_CLINIQUE || 'Clinique',
    NOM_CLINIQUE: process.env.VUE_APP_NOM_CLINIQUE || 'CLINIQUE',

    // Feature flags (convertir string en boolean)
    IS_SFE: process.env.VUE_APP_IS_SFE === 'true',
    CAN_SET_PAC: process.env.VUE_APP_CAN_SET_PAC === 'true',
    IS_MODELE_ANALYSE: process.env.VUE_APP_IS_MODELE_ANALYSE !== 'false'
}

export { cca_config }
export default cca_config
